// This file was auto-generated by Fern from our API Definition.
const PrimitiveTypeV1Values = {
    Integer: "INTEGER",
    /**
     * Within the range -2^53 to 2^53 */
    Long: "LONG",
    Uint: "UINT",
    Uint64: "UINT_64",
    Float: "FLOAT",
    Double: "DOUBLE",
    Boolean: "BOOLEAN",
    String: "STRING",
    Date: "DATE",
    DateTime: "DATE_TIME",
    DateTimeRfc2822: "DATE_TIME_RFC_2822",
    Uuid: "UUID",
    Base64: "BASE_64",
    BigInteger: "BIG_INTEGER",
};
export const PrimitiveTypeV1 = Object.assign(Object.assign({}, PrimitiveTypeV1Values), { _visit: (value, visitor) => {
        switch (value) {
            case PrimitiveTypeV1.Integer:
                return visitor.integer();
            case PrimitiveTypeV1.Long:
                return visitor.long();
            case PrimitiveTypeV1.Uint:
                return visitor.uint();
            case PrimitiveTypeV1.Uint64:
                return visitor.uint64();
            case PrimitiveTypeV1.Float:
                return visitor.float();
            case PrimitiveTypeV1.Double:
                return visitor.double();
            case PrimitiveTypeV1.Boolean:
                return visitor.boolean();
            case PrimitiveTypeV1.String:
                return visitor.string();
            case PrimitiveTypeV1.Date:
                return visitor.date();
            case PrimitiveTypeV1.DateTime:
                return visitor.dateTime();
            case PrimitiveTypeV1.DateTimeRfc2822:
                return visitor.dateTimeRfc2822();
            case PrimitiveTypeV1.Uuid:
                return visitor.uuid();
            case PrimitiveTypeV1.Base64:
                return visitor.base64();
            case PrimitiveTypeV1.BigInteger:
                return visitor.bigInteger();
            default:
                return visitor._other();
        }
    } });
